import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productInCart: [], // This can be used for storing product objects
  productInCartIds: [], // This is for fast lookup
  lastAction: null,
  myInfo: {}
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    initiateMyInfo: (state, action) => {
      state.myInfo = action.payload;
    },
    initiateCart: (state, action) => {
      state.productInCart = action.payload;
      state.productInCartIds = action.payload.map(item => item._id);
    },
    addToCart: (state, action) => {
      state.lastAction = { type: 'add', product: action.payload };
      state.productInCart.unshift(action.payload); // Add to the beginning
      state.productInCartIds.unshift(action.payload._id);
    },
    removeFromCart: (state, action) => {
      state.lastAction = { type: 'remove', productId: action.payload };
      state.productInCart = state.productInCart.filter(
        (item) => item._id !== action.payload
      );
      state.productInCartIds = state.productInCartIds.filter(
        (id) => id !== action.payload
      );
    },
    rollbackCart: (state, action) => {
      if (state.lastAction.type === 'add') {
        state.productInCart = state.productInCart.filter(
          (item) => item._id !== state.lastAction.product._id
        );
        state.productInCartIds = state.productInCartIds.filter(
          (id) => id !== state.lastAction.product._id
        );
      } else if (state.lastAction.type === 'remove') {
        state.productInCart.unshift(state.lastAction.product); // Add back to the beginning
        state.productInCartIds.unshift(state.lastAction.product._id);
      }
      state.lastAction = null;
    },
  },
});

export const { initiateMyInfo, initiateCart, addToCart, removeFromCart, rollbackCart } = userSlice.actions;

export const selectCartItems = (state) => state.user.productInCart;
export const selectCartItemIds = (state) => state.user.productInCartIds;
export const selectMyInfo = (state) => state.user.myInfo;

export default userSlice.reducer;